import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Phone, MapPin, Instagram, Music2, Youtube } from "lucide-react";

export default function Kontakt() {
  const cards = [
    { icon: Mail, label: "E-MAIL", value: "info@all-about-artists.de", href: "mailto:info@all-about-artists.de" },
    { icon: Phone, label: "TELEFON", value: "+49 711 72607514", href: "tel:+4971172607514" },
    { icon: MapPin, label: "ADRESSE", value: "Schöttlestraße 22, 70597 Stuttgart", href: null },
  ];
  const socials = [
    { Icon: Instagram, href: "https://www.instagram.com/crtr_group" },
    { Icon: Music2, href: "https://vm.tiktok.com/ZGd9UVkJf/" },
    { Icon: Youtube, href: "https://www.youtube.com/@CRTRGroup" },
  ];

  return (
    <section className="relative min-h-screen bg-transparent px-5 pb-28 pt-36 md:px-10">
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="mono-label mb-8 inline-flex items-center gap-2 text-xs text-white/60 transition-colors hover:text-[var(--crtr-yellow)]">
          <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
        </Link>

        <h1 className="font-display text-5xl text-white sm:text-6xl">
          Kontakt<span className="text-[var(--crtr-yellow)]">.</span>
        </h1>
        <p className="mt-4 max-w-xl text-white/60">
          Gute Menschen, gute Ideen, gute Gespräche. Schreib oder ruf uns an — wir freuen uns.
        </p>

        <div className="mt-12 grid gap-4 sm:grid-cols-3">
          {cards.map((c) => {
            const Inner = (
              <div className="group h-full rounded-2xl border border-white/10 bg-black/25 p-6 backdrop-blur-sm transition-colors hover:border-[var(--crtr-yellow)]">
                <c.icon className="h-6 w-6 text-[var(--crtr-yellow)]" strokeWidth={1.7} />
                <span className="mono-label mt-5 block text-[11px] text-white/50">{c.label}</span>
                <span className="mt-1 block text-[15px] leading-relaxed text-white">{c.value}</span>
              </div>
            );
            return c.href ? (
              <a key={c.label} href={c.href} className="block">{Inner}</a>
            ) : (
              <div key={c.label}>{Inner}</div>
            );
          })}
        </div>

        <div className="mt-12">
          <span className="mono-label block text-[11px] text-white/50">FOLLOW</span>
          <div className="mt-4 flex gap-3">
            {socials.map(({ Icon, href }, i) => (
              <a key={i} href={href} target="_blank" rel="noreferrer" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white/70 transition-colors hover:border-[var(--crtr-yellow)] hover:text-[var(--crtr-yellow)]">
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 rounded-2xl border border-white/10 bg-black/20 p-6 text-sm text-white/55">
          Ein direktes Kontaktformular folgt in Kürze. Bis dahin erreichst du uns am schnellsten per
          E-Mail oder Telefon.
        </div>
      </div>
    </section>
  );
}
